import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { INewImageModel } from 'src/app/core/models/interfaces/new-image-model';
import { LoadingService } from 'src/app/core/services/loading.service';
import { MediaService } from 'src/app/core/services/media.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { Thread, ThreadMessage } from '../../models/profile';
import { QuestionErrorService } from '../../services/question-error.service';

@Component({
  selector: 'app-ask-expert-save',
  templateUrl: './ask-expert-save.component.html',
  styleUrls: ['./ask-expert-save.component.scss'],
})
export class AskExpertSaveComponent implements OnInit {
  querySubs: Subscription;
  questionId: number;
  data: ThreadMessage;
  text: string = null;
  constructor(private questionErrorService: QuestionErrorService,
    private activatedRoute: ActivatedRoute,
    private loadingService: LoadingService,
    private navigationService: NavigationService,
    private mediaService: MediaService,
    private sanitizer: DomSanitizer) { }

  ngOnInit() { }

  ionViewDidEnter() {
    // this.sanitizer.bypassSecurityTrustResourceUrl
    this.querySubs = this.activatedRoute.queryParams.subscribe(e => {
      if (e["id"]) {
        this.questionId = +e["id"];
        this.getQuestion();
      }
    });
  }

  getQuestion() {
    this.loadingService.showLoading();
    this.questionErrorService.getQuestionByThread(this.questionId).subscribe(res => {
      this.loadingService.hideLoading();
      if (res.IsSuccess) {
        this.data = res.Data;
        setTimeout(() => {
          this.scroll();
        }, 100);
      }
    });
  }

  goBack() {
    this.navigationService.goBack();
  }

  close() {
    this.loadingService.showLoading();
    this.questionErrorService.stopThread(this.questionId).subscribe(e => {
      if (e.IsSuccess) {
        this.getQuestion();
      }
      this.loadingService.hideLoading();
    })
  }

  file: INewImageModel;
  openMediaOptions() {
    this.mediaService.openAddMediaSheet().subscribe(
      (res: string) => {
        if (res == "camera") {
          this.mediaService.openAddPhotoSheet().subscribe(
            (res: INewImageModel) => {
              this.file = res;
            }, err => {
            })
        } else if (res == "video") {
          this.mediaService.captureVideo().subscribe(res => {
            this.file = res;
          });
        } else if (res == "audio") {
          this.mediaService.captureAudio().subscribe(res => {
            this.file = res;
          });
        }
      }, err => {
      })
  }

  scroll() {
    let row = document.getElementById("talk");
    row?.scrollIntoView({ inline: "end", behavior: "auto", block: "end" })
  }

  save() {
    let id = Date.now();
    if (!this.questionId) {
      let formData: FormData = new FormData();
      formData.append("ProblemContent", this.text);
      if (this.file)
        formData.append("File", this.file.image, `image_${Date.now()}.${this.file.format}`);
      this.data = {
        IsClosed: false,
        Threads: [{
          Date: null,
          File: this.file?.src,
          ProblemContent: this.text,
          FromWho: "F",
          Id: id,
          MasterId: 0,
          TypeName: !this.file ? "text" : this.file.mediaType
        }
        ]
      }
      this.questionErrorService.saveQuestion(formData).subscribe(e => {
        if (e.IsSuccess) {
          this.file = null;
          this.scroll();
          this.text = null;
          this.questionId = e.Data;
          let message = this.data.Threads.find(e => e.Id == id)
          message.Date = (new Date()).toString();
          message.MasterId = this.questionId;
          this.getQuestion();
        }
      })
    } else {
      let formData: FormData = new FormData();
      formData.append("ProblemContent", this.text);
      formData.append("MasterId", this.questionId.toString());
      if (this.file)
        formData.append("File", this.file.image, `image_${Date.now()}.${this.file.format}`);

      this.data.Threads.push({
        Date: null,
        File: this.file?.src,
        ProblemContent: this.text,
        FromWho: "F",
        Id: id,
        MasterId: this.questionId,
        TypeName: !this.file ? "text" : this.file.mediaType
      });
      this.questionErrorService.saveQuestionThread(formData).subscribe(e => {
        if (e.IsSuccess) {
          this.file = null;
          this.text = null;
          this.scroll();
          let message = this.data.Threads.find(e => e.Id == id)
          message.Date = (new Date()).toString();
          this.getQuestion();
        }
      })
    }

  }
}
